<template>
  <div class="text-black flex items-center overflown-y-scroll">
    <div class="container mx-auto p-4 flex flex-wrap items-center">
      <div class="w-full md:w-5/12 text-center p-4">
        <img src="../assets/logoNavbar.png" alt="Not Found" />
      </div>
      <div class="w-full md:w-7/12 text-center md:text-left p-4">
        <div class="text-6xl font-medium">404</div>
        <div class="text-xl md:text-3xl font-medium mb-4">
          Oops. The tenant you search is not found.
        </div>
        <div class="text-lg mb-8">
          You may have mistyped the tenant name or the tenant is not on the list.
        </div>
        <button
        @click.prevent="viewAll"
        class="bg-red-700 text-gray-100 w-max-content text-white py-2 px-5 font-bold rounded cursor-pointer hover:bg-red-900">Go Back</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    viewAll () {
      this.$store.dispatch('fetchTenants')
    }
  }
}
</script>

<style>

</style>
